// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTable-HeaderCell_cls1__ESxXh","cls2":"VeloTable-HeaderCell_cls2__DdmcU VeloTable-HeaderCell_cls1__ESxXh","sortable":"VeloTable-HeaderCell_sortable__hcUWS"};